// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4bc0aa22] .v-btn.v-popup-activator{color:#7f839c}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
